import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IconMessages } from '@rossum/ui/icons/tabler';
import { Badge, IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';
import { Annotation } from '../../../../types/annotation';
import { CommentsDrawer } from '../../../document-comments/comments-thread';
import { useGetComments } from '../../../document-comments/core';

type CommentsDrawerButtonProps = { annotation: Annotation };

export const CommentsDrawerButton = ({
  annotation,
}: CommentsDrawerButtonProps) => {
  const intl = useIntl();
  const [commentDrawerAnnotation, setCommentDrawerAnnotation] = useState<
    number | null
  >(null);

  const { data: comments, isFetching } = useGetComments({
    annotation: annotation.id,
  });

  return (
    <>
      <CommentsDrawer
        open={!!commentDrawerAnnotation}
        annotation={annotation}
        comments={comments}
        isLoading={isFetching}
        onClose={() => setCommentDrawerAnnotation(null)}
      />
      <Tooltip
        title={intl.formatMessage({
          id: 'components.sidebarV2.topbar.actions.documentComments',
        })}
      >
        <IconButton
          size="medium"
          onClick={() => setCommentDrawerAnnotation(annotation.id)}
          data-cy="sidebar-toggle-document-comments"
        >
          <Badge
            color="secondary"
            badgeContent={comments?.length}
            invisible={!comments || comments.length === 0}
            sx={{
              pointerEvents: 'none',
            }}
          >
            <SvgIcon fontSize="medium">
              <IconMessages />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
    </>
  );
};
